/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Ocop_Level_RequiredInputs */

const vi_error_shop_ocop_level_required = /** @type {(inputs: Error_Shop_Ocop_Level_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn cấp OCOP khi bật hiện huy hiệu: Cấp tỉnh hoặc Cấp quốc gia.`)
};

/**

* @param {Error_Shop_Ocop_Level_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_ocop_level_required = /** @type {((inputs?: Error_Shop_Ocop_Level_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Ocop_Level_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_ocop_level_required(inputs)
});